import { debounce } from "@/lib/debounce";
import { loadCSS } from "@/lib/loadCSS";
import { getText } from "@/lib/dom/getText";
import { showElement } from "@/lib/dom/showElement";
import { hideElement } from "@/lib/dom/hideElement";
import Broweser from "@/lib/browser";
import { addStyle } from "@/lib/dom/addStyle";
import { removeStyle } from "@/lib/dom/removeStyle";
import { getHeight } from "@/lib/dom/getHeight";
import { trigger } from "@/lib/dom/trigger";
import { removeClass } from "@/lib/dom/removeClass";
import { addClass } from "@/lib/dom/addClass";
import { on } from "@/lib/dom/on";
import { off } from "@/lib/dom/off";

let controller = new AbortController();
let signal = controller.signal;
const globalData: Record<string, string> = {};

const setupAutoComplete = async () => {
  const headerSearch = document.querySelector(".home-serch");
  const wrapper = document.querySelector(".global-wrapper");

  //loadCSS(window.siteConfig.webResourcePath + 'assets/css/search-suggestions.css');
  await import('@/share/styles/header/search-suggestion.less')

  const txtSearch = document.getElementById("ucHeader_txtSearch") as HTMLInputElement;

  txtSearch.setAttribute("autocomplete", "off")

  let iscompositionend = 0;
  let autoTotal = 0;
  let autoIndex = -1;
  let lastSearchValue = txtSearch.value;


  type SuggestionGroup = {
    key: keyof Suggestions,
    type: number,
    hasContent?: boolean
    title?: string
  }

  const groups: Array<SuggestionGroup> = [
    { key: "Suggestions", type: 1 },
    { key: "Categories", type: 2 },
    { key: "Products", type: 5, hasContent: true },
    { key: "Resources", type: 3, hasContent: true },
    { key: "PlatinumBox", type: 4, title: "Platinum Box", hasContent: true },
  ]

  function buildSuggestionItem(type: keyof Suggestions, sugg: string[]): HTMLElement {
    const div = document.createElement("div")

    switch (type) {
      case "Suggestions":
        {
          const result = document.createElement("div")
          const count = document.createElement("div") as HTMLDivElement

          result.className = "s_val"
          result.innerHTML = sugg[0]

          count.className = "s_val_right"
          count.innerHTML = `${sugg[1]}<span class="t-con">_</span>results`

          div.appendChild(result)
          div.appendChild(count)
        }
        break;
      case "Categories":
        {
          const result = document.createElement("div")
          const hidValue = document.createElement("input") as HTMLInputElement
          const count = document.createElement("div") as HTMLDivElement

          result.className = "s_val"
          result.innerHTML = sugg[0]
          hidValue.type = "hidden"
          hidValue.value = sugg[2]
          result.append(hidValue)

          count.className = "s_val_right"
          count.innerHTML = `${sugg[1]}<span class="t-con">_</span>results`

          div.appendChild(result)
          div.appendChild(count)
        }
        break;
      case "Products":
      case "Resources":
      case "PlatinumBox":
        {
          const result = document.createElement("div")

          result.className = "s_val"
          result.innerHTML = sugg[0]

          div.appendChild(result)
        }
        break;
    }

    return div
  }

  /**
   * 显示自动完成
   * @param data 
   */
  const showAutoComplete = (val: string, data: Suggestions) => {

    autoTotal = data.Suggestions.length + data.Categories.length + data.Resources.length + data.PlatinumBox.length + data.Products.length;

    let autoComplete = document.getElementById('autoComplete');
    if (autoComplete) {
      autoComplete.remove();
    }

    if (autoTotal == 0 && data.ProductIDs.length == 0) {
      return;
    }


    autoComplete = document.createElement("div") as HTMLDivElement
    autoComplete.id = 'autoComplete'
    autoComplete.className = 'search-suggestion'

    autoComplete.style.visibility = 'hidden'; // 等效于 jQuery 的 .css('visibility', 'hidden')
    autoComplete.style.display = 'block'; // 等效于 jQuery 的 .show() 

    txtSearch.insertAdjacentElement("afterend", autoComplete)

    const suggestionGroups = document.createElement("div") as HTMLDivElement
    suggestionGroups.className = 'search-suggestion__groups'


    for (const group of groups) {
      const groupItems = data[group.key]
      if (!groupItems || !groupItems.length) continue;

      const divTitle = document.createElement("div") as HTMLDivElement
      divTitle.textContent = group.title ?? group.key
      divTitle.className = "search-suggestion__title"

      const divItems = document.createElement("div") as HTMLDivElement

      for (let x = 0; x < groupItems.length; x++) {
        const item = groupItems[x]
        const sugg = item.split('_:_');
        const divItem = buildSuggestionItem(group.key, sugg)

        divItem.setAttribute("d-type", group.type.toString())

        divItem.className = "search-suggestion__item"

        divItems.appendChild(divItem)

        if (group.hasContent) {
          const text = getText(sugg[0])
          globalData[text] = sugg[1]
        }
      }

      const suggestionGroup = document.createElement("div") as HTMLDivElement
      suggestionGroup.className = 'search-suggestion__group'

      suggestionGroup.appendChild(divTitle)
      suggestionGroup.appendChild(divItems)

      // append to groups
      suggestionGroups.appendChild(suggestionGroup)
    }

    const suggestionContainer = document.createElement("div") as HTMLDivElement
    suggestionContainer.className = 'search-suggestion__container'
    const suggestionPossibles = document.createElement("div") as HTMLDivElement
    suggestionPossibles.className = 'search-suggestion__possibles'

    suggestionContainer.append(suggestionGroups)
    suggestionContainer.append(suggestionPossibles)
    autoComplete.append(suggestionContainer)

    autoComplete.style.display = 'none'; // 等效于 jQuery 的 .hide()
    autoComplete.style.visibility = '';   // 等效于 jQuery 的 .css('visibility', '')

    autoIndex = -1;

    suggestionGroups.querySelectorAll(".s_val").forEach((el, idx) => {
      if (autoIndex < 0 && el.textContent == txtSearch.value) autoIndex = idx;
    })

    /**
     * 
     * @param productTags 
     * @param key 
     */
    const AutoRight = (productTags: string[], key: string) => {
      const detailright = document.querySelector('.search-suggestion__possibles')!;

      if (window.getComputedStyle(detailright).display == "none") {
        return;
      }
      detailright.innerHTML = ""

      let t = 'Top';
      if (productTags.length == 0)
        t = 'No';


      detailright?.insertAdjacentHTML('beforeend', `
            <div class="search-suggestion__products">
                <h2>Possible item matches</h2>
                <ul>${productTags.map(tag => `<li>${tag}</li>`).join('')}</ul>
                ${productTags.length > 0 ? `<div class="allpossibleitem">
                <a href="${document.querySelector('.ui2-focus a')?.getAttribute('href') ?? ''}">See all possible item matches ></a></div>` : ''}
            </div>`);

      // 处理 detailright 内部 a 标签的点击事件
      const detailRightLinks = document.querySelectorAll('.search-suggestion__possibles a');
      detailRightLinks.forEach(link => {
        link.addEventListener('click', (event: Event) => {
          event.preventDefault(); // 阻止默认行为
          const href = (link as HTMLAnchorElement).getAttribute('href');
          if (href) {
            window.location.href = href; // 导航到点击的链接
          }
        });
      });

      // ResetSugHight()
    }
    /*  AutoRight 结束 */


    let autoRightController = new AbortController();
    let autoRightSignal = autoRightController.signal;

    const GetAutoCompleteRight = (val: string, extendType: string) => {
      if (autoRightController && autoRightController.abort) {
        autoRightController.abort()
      }
      autoRightController = new AbortController();   // 新建一个AbortController实例
      autoRightSignal = autoRightController.signal;    // signal是AbortController实例的属性

      const autoReadyElement = document.getElementById('autoReady');
      if (autoReadyElement) {
        autoReadyElement.remove(); // 使用原生 DOM 的 remove() 方法
      }

      const JSuggestion = {
        key: val,
        extendType: extendType
      }
      fetch('/AjaxAutoComplete.aspx/GetSuggestionContent', {
        signal: autoRightSignal,
        method: 'POST', // 请求方法
        headers: {
          'Content-Type': 'application/json', // 指定发送的数据格式为 JSON
        },
        body: JSON.stringify({ obj: JSuggestion }) // 将数据转换为 JSON 字符串发送
      }).then(f => f.json())
        .then(f => {
          const data = JSON.parse(f.d)
          AutoRight(data.ProductIDs, data.key);
        }).catch((err) => {
        })
    }


    // 获取所有 #autoLeft li 元素并移除 'ui-focus' 类
    const suggestItems = document.querySelectorAll('.search-suggestion__item') as NodeListOf<HTMLElement>;
    suggestItems.forEach((item, index) => {
      item.addEventListener('mouseover', (event: MouseEvent) => {
        // 这里要使用防抖

        //让所有的元素都移除 'ui-focus' 类

        removeClass(suggestItems, 'ui-focus');
        addClass(item, 'ui-focus');

        removeClass(suggestItems, 'ui2-focus');
        addClass(item, 'ui2-focus');

        removeClass(suggestionGroups.querySelectorAll('.t-con'), 't-con2');
        addClass(item.querySelectorAll('.t-con'), 't-con2');

        autoIndex = index;

        const detailright = document.querySelector('.search-suggestion__possibles')!;

        if (window.getComputedStyle(detailright).display == "none") {
          return;
        }

        const dtype = item.getAttribute('d-type');
        // catgegory
        if (dtype == '1') {
          GetAutoCompleteRight(getText(item.querySelector('.s_val')!), dtype);
        }
        else if (dtype == '2') {
          const text = item.querySelector('.s_val input')
          if (text) {
            GetAutoCompleteRight((text as HTMLInputElement).value ?? '', dtype);
          }
        }
        else if (dtype == '3' || dtype == '4' || dtype == '5') {
          if (autoRightController && autoRightController.abort) {
            autoRightController.abort()
          }
          const possibles = document.querySelector('.search-suggestion__possibles');
          if (possibles) { possibles.innerHTML = ""; }

          const autoCompleteElement = document.getElementById('autoComplete');

          if (autoCompleteElement) {

            const s_val = item.querySelector('.s_val');
            let text = '';
            if (s_val) {
              text = s_val.textContent ?? '';
            }

            const resourceBody = globalData[text];

            possibles?.insertAdjacentHTML('beforeend', `<div class="search-suggestion__products">${resourceBody}</div>`);
          }

        }
        //重新设置高度
        // ResetSugHight()
      })

    });

    // set default selected
    // 检查是否有对应的 <li> 元素
    let targetSuggestion: HTMLElement | null = null;
    if (autoIndex < 0) {
      // 如果是负数就取最后一条记录
      const index = suggestItems.length - 1;
      targetSuggestion = suggestItems[index];
      autoIndex = index
    } else if (autoIndex >= 0 && autoIndex < suggestItems.length) {
      targetSuggestion = suggestItems[autoIndex];
    }
    if (targetSuggestion) {
      // 触发 mouseover 事件
      trigger(targetSuggestion, 'mouseover', {
        bubbles: true,
        cancelable: true
      });
    }

    autoIndex = -1;
    removeClass(suggestItems, 'ui-focus');

    document.querySelectorAll('.search-suggestion__item .s_val').forEach((elem, index) => {
      // var s_val = $(this);
      on(elem.parentNode!, 'click', function () {
        window.location.href = elem.querySelectorAll('a')[0]!.getAttribute('href')!;
        return false;
      });
    });

    //AutoRight(d.ProductIDs, val);
    AutoRight(data.ProductIDs, val);

    BindSearchKeyDown()

    /**
     *  $('#autoComplete1').prepend('<div class="search-suggestion__arrow"></div></div>');
                $('#autoComplete1').show();
     */
    autoComplete.insertAdjacentHTML('afterbegin',
      '<div class="search-suggestion__arrow"></div>'
    ); // 等效于 jQuery 的 .prepend()
    autoComplete.style.display = 'block'; // 等效于 jQuery 的 .show()

    showElement(autoComplete);
  }


  /**
   * 隐藏自动完成（当搜索词是空时触发）
   */
  const hideAutoComplete = () => {
    const autoComplete = document.getElementById('autoComplete') as HTMLElement;
    if (autoComplete) {
      autoComplete.style.display = "none";
    }
  }


  const ResetSugHight = () => {
    const autoComplete = document.getElementById('autoComplete')! as HTMLElement;
    const _group = autoComplete.querySelector('.search-suggestion__groups')! as HTMLElement;

    removeStyle(_group, 'height');
    removeStyle(document.querySelector('.search-suggestion__products'), 'height');

    let vHeight = getHeight(_group);


    if (getHeight(document.querySelector('.search-suggestion__possibles')!) > vHeight) {
      vHeight = getHeight(document.querySelector('.search-suggestion__possibles')!);
    }
    if (vHeight < 450) {
      vHeight = 450;
    }
    addStyle(_group, 'height', vHeight + 'px');
    addStyle(document.querySelector('.search-suggestion__products')! as HTMLElement, 'height', vHeight + 'px');
  }


  /**
   *  获取自动完成
   * @param val 
   */
  const GetAutoComplete = (val: string) => {
    if (controller && controller.abort) {
      controller.abort()
    }
    controller = new AbortController();   // 新建一个AbortController实例
    signal = controller.signal;    // signal是AbortController实例的属性

    const JSuggestion = {
      key: val,
      extendType: 0
    }

    fetch('/AjaxAutoComplete.aspx/GetSuggestions', {
      signal: signal,
      method: 'POST', // 请求方法
      headers: {
        'Content-Type': 'application/json', // 指定发送的数据格式为 JSON
      },
      body: JSON.stringify({ obj: JSuggestion }) // 将数据转换为 JSON 字符串发送
    }).then(f => f.json())
      .then(f => {
        const data = JSON.parse(f.d)
        console.log(data)
        showAutoComplete(val, data);
      }).catch((ex) => {
      })
  }

  /**
   * 搜索词输入框的输入事件，使用防抖函数
   */
  const debounceSearch = debounce(GetAutoComplete, 500);

  /**
   * 处理搜索输入框的键盘按下事件
   * 只支持上下键
   * @param event 
   */
  const handleSearchKeyDown = (event: KeyboardEvent) => {
    if (event.key == 'ArrowUp' || event.key == 'ArrowDown') {
      if (event.key == 'ArrowUp') {
        if (autoIndex <= 0)
          return;
        autoIndex--;
      } else {
        if (autoIndex == autoTotal - 1) {
          return;
        }
        autoIndex++;
      }
      /**
       *          $(this).val($('#autoLeft li').eq(autoIndex).find('.s_val').text());
                $('#autoLeft li').eq(autoIndex).mouseover();
                $('body').data('key_down_select', $('.ui2-focus a').attr('href'));
       */
      const currentNode = document.querySelectorAll('.search-suggestion__item')[autoIndex];
      txtSearch.value = getText(currentNode.querySelector('.s_val')!)?.trim() ?? ''

      trigger(currentNode, 'mouseover', {
        bubbles: true,
        cancelable: true
      })

      globalData['key_down_select'] = currentNode.querySelector('.ui2-focus a')!.getAttribute('href') ?? ''
      return;
    }
  }

  const BindSearchKeyDown = () => {
    if (autoTotal > 1) {
      off(txtSearch, 'keydown', handleSearchKeyDown);
      delete globalData['key_down_select'];
      on(txtSearch, 'keydown', handleSearchKeyDown);
    }
  }
  /**
   * 获得焦点时触发
   */
  txtSearch.addEventListener('focus', (event: Event) => {
    iscompositionend = 0;
    const el = event.target as HTMLInputElement;
    lastSearchValue = txtSearch.value.trim();
    debounceSearch(lastSearchValue);
  });

  /**
   * 搜索输入框添加keyup事件
   */
  txtSearch.addEventListener('keyup', (event: KeyboardEvent) => {
    const value = txtSearch.value.trim();
    const target = event.target as HTMLInputElement;
    if (iscompositionend == 1) {
      iscompositionend = 0;
      debounceSearch(value);
      return;
    }
    if (event.key == 'ArrowUp') {
      // 上箭头
      /**
       *      var t = $(this).val();
            $(this).focus().val('').val(t);
       */
      // txtSearch.value = value;
      // trigger(txtSearch, 'focus', {

      // })
    }
    if (event.key == 'Enter') {
      //回车键
      const autoComplete = document.getElementById("autoComplete");
      if (autoComplete) {
        hideElement(autoComplete);
      }
      // @ts-ignore
      searchForm(target.parentNode)
    } else if (event.key != 'ArrowUp' && event.key != 'ArrowLeft' && event.key != 'ArrowRight' && event.key != 'ArrowDown' && value != lastSearchValue) {
      if (txtSearch.dataset['closed']) {
        return;
      }
      lastSearchValue = value;
      debounceSearch(value);
      // if (value.length > 0) {
      //   debounceSearch(value);
      // } else {
      //   hideAutoComplete()
      // }
    }
  }, {
    passive: true
  });
  txtSearch.addEventListener('compositionend', () => {
    iscompositionend = 1;
  }, false)

  //JS加载完成后，发现用户已经输入搜索词，自动触发
  // if (txtSearch.value.length > 0) {
  GetAutoComplete(txtSearch.value);
  // }

  /**
   * 隐藏搜索下拉框
   * @param event 
   */
  const hideAutoCompleteEvent = (event: Event): void => {
    // 自定义的隐藏自动完成事件逻辑
    const target = event.target as HTMLElement;

    const autoComplete = document.getElementById('autoComplete');
    const txtSearch = document.getElementById('ucHeader_txtSearch');

    // 如果没有自动完成框和搜索框，直接返回
    if (!autoComplete || !txtSearch) return;

    // 如果点击的元素是 #autoComplete1 或者 #ucHeader_txtSearch 的子元素，直接返回
    if (autoComplete.contains(target) || txtSearch.contains(target)) {
      return;
    }

    // 隐藏对象
    autoComplete.style.display = 'none';
  }

  // 页面空白地方点击时，隐藏搜索下拉框
  document.addEventListener('click', (event: MouseEvent) => {
    hideAutoCompleteEvent(event);
  });

}

/*
   * 搜索框的键盘事件
 */
const searchForm = (el: Element | null) => {
  const txtSearch = document.getElementById("ucHeader_txtSearch") as HTMLInputElement;
  let txtSearch_val = txtSearch.value.trim();
  if (el) {
    const input = el.querySelector("#ucHeader_txtSearch") as HTMLInputElement;
    if (input) {
      txtSearch_val = input.value.trim();
    }
  }
  if (txtSearch_val == 'Search by Keywords, Brand or Item #') {
    txtSearch_val = '';
  }

  const isHomePage = window.location.pathname === '/' || window.location.pathname === ''

  if (isHomePage || txtSearch_val.length > 0) {
    //@ts-ignore
    let url = typeof (searchUr) == 'undefined' ? '/search?' : searchUr;
    if (txtSearch_val.length > 0) {
      url += ('searchterm=' + encodeURIComponent(txtSearch_val));
    }
    window.dataLayer.push({
      "event": "search",
      "search_keywords": txtSearch_val
    });
    if (globalData['key_down_select']) {
      const selectUrl = globalData['key_down_select'];
      if (selectUrl.lastIndexOf('searchterm=') != -1)
        url = '/search?searchterm=' + encodeURIComponent(selectUrl.substring(selectUrl.lastIndexOf('searchterm=') + 'searchterm='.length));
      else
        url = selectUrl;
    }
    const checkPreProduction = document.getElementById("checkPreProduction");
    if (checkPreProduction) {
      if (checkPreProduction.getAttribute('checked') == 'checked') {
        url += url.indexOf('?') == -1 ? "?" : "&" + "preproduction=1";
      }
    }
    window.location = url;
  }
  return false;
}

Object.assign(globalThis, { searchForm })

export {
  setupAutoComplete
}